import http from '../libs/http';

export const getOrderDetails = ({merchantId, orderId}) => {

    const endpoint = `/v3/merchants/${merchantId}/orders/${orderId}?expand=lineItems,payments,refunds`;
    return http({endpoint});
};
